import {useEffect} from "react";
import {useSearchParams} from "react-router";
import ValidateCpf from "../../../../../components/validation/validate-cpf.jsx";

const useIndividualUrlParams = (setIndividual, setIsCpfValid) => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const cpf = searchParams.get("cpf");
        const name = searchParams.get("name");

        if (!cpf && !name) return;

        if (cpf) {
            ValidateCpf(cpf, setIsCpfValid);
        }

        setIndividual(prev => ({
            ...prev,
            ...(cpf ? {cpf} : {}),
            ...(name ? {name} : {})
        }));
    }, [searchParams, setIndividual]);
};

export default useIndividualUrlParams;
